import { useServiceNameOrNull } from '@consigli/hooks';
import { ServiceName, type Finding } from '@consigli/types';

import { findingContractor } from './offer-references';

/**
 * Resolve the bid provider a finding belongs to, for the new "Offer (Bid
 * Review)" service only. The findings page is shared across services and has no
 * per-bid tabs, so bid-gap findings from every contractor are listed together;
 * this lets a card render the provider as a tag. Returns `undefined` outside the
 * new Bid Review service (the legacy Offer service keeps its old findings view)
 * or when the finding can't be attributed. The contractor is read from the
 * finding's own `reference` metadata, so no blob fetch is required.
 */
export const useFindingContractor = (finding: Finding): string | undefined => {
  const serviceName = useServiceNameOrNull();
  const isBidReview = serviceName === ServiceName.BID_REVIEW;

  return isBidReview ? findingContractor(finding) : undefined;
};
